import { CustomerInfo } from "../CustomerInfo"

export const setDeliveryV2Enabled = (data?: CustomerInfo) =>
  sessionStorage.setItem(DeliveryV2EnabledStorageKey, JSON.stringify(data?.enableDeliveryV2))

export const getDeliveryDefaultLink = () =>
  sessionStorage.getItem(DeliveryV2EnabledStorageKey) === "true"
    ? "/delivery-v2/app"
    : "/delivery/app"

const DeliveryV2EnabledStorageKey = "deliveryV2Enabled"
